export default {
	data() {
		return {
			loading: false,
			showDialog: false,

			items: [],

			storeModel: '',

			dialogItem: null,

			deleteItem: null,
			deleteDialog: false,
		};
	},

	methods: {
		openDialog(info = {}) {
			this.dialogItem = null;

			this.showDialog = true;

			if (info.item) {
				this.dialogItem = info.item;
			}
		},

		fetch(parameters = {}) {
			this.loading = true;
			this.$store
				.dispatch(this.storeModel, {
					id: this.employeeId,
					...parameters,
				})
				.then((res) => {
					this.items = res;
				})
				.catch((e) => {
					e.default && e.default();
				})
				.finally(() => {
					this.loading = false;
				});
		},
	},
};
